import { http } from 'plugins/http'
import { getData } from 'utils/get'


// get all company domains
export const getDomains = (id) => http.get('/companies/domains/listing?company='+id).then(getData)

export const geteditDomains = (id) => http.get('/companies/domains/edit/'+id).then(getData)


export const addNewDomain = ({ name,comp_id }) => http.post('/companies/domains', { name,comp_id }).then(getData)
export const updateDomainData = ({ id,comp_id }) => http.post('/companies/domains/update', { id,comp_id }).then(getData)

export const verifyNewDomain = ({ id }) => http.post('/companies/domains/verify', { id }).then(getData)

export const verifyTxtRecord = ({ id }) => http.post('/companies/domains/verifytxtrecord', { id }).then(getData)

export const deleteDomain = ({ id }) => http.delete('/companies/domains/'+id).then(getData)

export const getCompanySubOrg = () => http.get('/reports/company/suborg').then(getData)





// WEBPACK FOOTER //
// ./src/app/company/services.js